import React from 'react'

const Welcome = () => {
  return (
    <div>
         <h2>There is No Leagues Yet !!</h2>
    </div>
  )
}

export default Welcome
